import {
    EVENT_DELETE_OPEN_MODAL,
    EVENT_DELETE_REQUEST,
    EVENT_DELETE_RESULT,
} from 'Redux/actionTypes';

export const eventDeleteOpenModal = (open, event) => ({
    type: EVENT_DELETE_OPEN_MODAL,
    payload: { open, event }
})

export const eventDeleteRequest = (data) => ({
    type: EVENT_DELETE_REQUEST,
    payload: data
})

export const eventDeleteResult = (data) => ({
    type: EVENT_DELETE_RESULT,
    payload: data
})